const termsOfService = {
  title: 'Uvjeti korištenja',
  description:
    'Molimo pregledajte i prihvatite uvjete korištenja za nastavak rada u aplikaciji.',
  summaryTitle: 'Ključne točke:',
  titleLine1: 'Namijenjeno kliničkoj uporabi',
  summaryLine1:
    'Ovaj alat namijenjen je kvalificiranim medicinskim i zdravstvenim djelatnicima.',
  titleLine2: 'Obavezna neovisna provjera',
  summaryLine2:
    'Ovaj alat koristi umjetnu inteligenciju koja može pogriješiti. Morate neovisno pregledati i potvrditi sve izlazne podatke.',
  titleLine3: 'Odgovornost korisnika',
  summaryLine3:
    'Vi, kao korisnik, preuzimate punu odgovornost za točnost medicinskih izvještaja i drugog sadržaja kreiranog ovim alatom.',
  description1: 'Nastavkom korištenja prihvaćate cjelokupne ',
  linkHref: 'https://medical.voicefill.ai/terms-and-conditions.html',
  linkText: 'uvjete korištenja',
  description2: '.',
  acceptTerms: 'Slažem se',
};

export default termsOfService;
